var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"audio-player-container"}},[(_vm.audioSources.length)?_c('nonfiction-player',{ref:"insigthPlayer",attrs:{"sources":_vm.selectedAudio},on:{"end":_vm.onPlaybackEnd,"play":_vm.onPlay,"pause":_vm.onPause,"load":_vm.onLoad,"stop":_vm.onStop}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }